import React, {useEffect, useRef, useState} from 'react';
import useAuth from "../../hooks/useAuth";
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import BillSummary from "./BillSummary";
import Pagination from "../Customer/Pagination";

function TransactionList() {
    const [expanded, setExpanded] = useState(-1);
    const {auth} = useAuth();
    const axiosPrivate = useAxiosIntercept();
    const [transactionData, setTransactionData] =  useState([]);
    const [transactionType, setTransactionType] = useState("debit");
    const [isLoading, setIsLoading] = useState(false);
    const [summaryData, setSummaryData] = useState([]);
    const [selected, setSelected] = useState(0);
    const [openSelect, setOpenSelect] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage, setUsersPerPage] = useState(10);
    const [total_records, setTotalRecords] = useState(0);

    const getBookingDetails = async (order_id) => {
        setSummaryData([]);
        try{
            const url = process.env.REACT_APP_GET_ORDER_DETAILS_BY_ORDER_ID;
            let payload = {};
            if(order_id){
                payload.order_id = order_id;
            }
            const response = await axiosPrivate.post(url, payload);
            if(response?.data?.response?.data) {
                if(response?.data?.response?.data?.booking_records != null){
                    setSummaryData(response?.data?.response?.data?.booking_records[0]);
                    return true;
                }
                else{
                    return false;
                }
            }
        }
        catch (err){
            console.log("something went wrong ",err);
        }
    }

    const getInvoiceData = async (order_id) => {
        try{
            let url = process.env.REACT_APP_GET_INVOICE;
            url = `${url}&wallet_id=${auth.wallet_id}&order_id=${order_id}`;

            const response = await axiosPrivate.get(url);
            if(response?.data?.response?.data) {
                if(response?.data?.response?.data?.file != null){
                    setSummaryData(response?.data?.response?.data?.file);
                    return response?.data?.response?.data?.file;
                }
                else{
                    return false;
                }
            }
        }
        catch (err){
            console.log("something went wrong ",err);
        }
    }


    const getTransactions = async (fromDate, toDate) =>{
        try{
            let url =  process.env.REACT_APP_GET_BILLING_TRANSACTION;
            url = `${url}&wallet_id=${auth.wallet_id}`;
            let payload = {};
            payload.extend=1
            payload.wallet_id = auth.wallet_id;
            payload.transaction_type = transactionType;
            payload.page = currentPage;
            payload.no_of_entries = 10;
            if(fromDate && toDate){
                payload.from_date = fromDate;
                payload.to_date = toDate;
            }

            setIsLoading(true);

            let response = await axiosPrivate.post(url,payload);
            setIsLoading(false);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch (err){
            console.log("something went wrong",err);
        }
    }


    useEffect(()=>{
        if(selected==0){
            getTransactions().then((data)=>{
                if(data?.count)
                    setTotalRecords(data.count);
                if(data?.transactions != null)
                    setTransactionData(data.transactions);
            });
        }
        else if(selected==3){
            getTransactionData(3)
        }
        else if(selected==6){
            getTransactionData(6)
        }
        else if(selected==12){
            getTransactionData(12)
        }

    },[transactionType, auth.wallet_id, currentPage, selected])

    // useEffect(()=>{
    //     setCurrentPage(1);
    // },[transactionType, selected])

    // const getTransactionData = (data) =>{
    //     let fromDate, toDate;
    //     const today = new Date();
    //     const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    //     const lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
    //
    //     const year = lastDayOfPreviousMonth.getFullYear();
    //     const month = String(lastDayOfPreviousMonth.getMonth() + 1).padStart(2, '0');
    //     const day = String(lastDayOfPreviousMonth.getDate()).padStart(2, '0');
    //     const formattedDate = `${year}-${month}-${day}`;
    //     toDate= formattedDate;
    //
    //     const firstDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
    //     const firstDayOfThirdMonthBefore = new Date(firstDayOfPreviousMonth);
    //     if(data == 0){
    //         fromDate = 0;
    //     }
    //
    //     else if(data == 3){
    //         firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 2);
    //         firstDayOfThirdMonthBefore.setDate(1);
    //         fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
    //         console.log(fromDate);
    //     }
    //     else if(data == 6){
    //         firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 5);
    //         firstDayOfThirdMonthBefore.setDate(1);
    //         fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
    //
    //     }
    //     else if(data == 12){
    //         firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 11);
    //         firstDayOfThirdMonthBefore.setDate(1);
    //         fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
    //     }
    //
    //     getTransactions(fromDate, toDate).then((data)=>{
    //         if(data?.count)
    //             setTotalRecords(data.count);
    //
    //         if(data?.transactions != null)
    //             setTransactionData(data.transactions);
    //     });
    // }

    const getTransactionData = (data) =>{
        let fromDate, toDate;
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);

        const year = lastDayOfPreviousMonth.getFullYear();
        const month = String(lastDayOfPreviousMonth.getMonth() + 1).padStart(2, '0');
        const day = String(lastDayOfPreviousMonth.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        toDate= formattedDate;

        const firstDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
        const firstDayOfThirdMonthBefore = new Date(firstDayOfPreviousMonth);
        firstDayOfThirdMonthBefore.setDate(1); // set to the first day of the month
        if(data == 0){
            fromDate = 0;
        }

        else if(data == 3){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 2);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
            console.log(fromDate);
        }
        else if(data == 6){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 5);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);

        }
        else if(data == 12){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 11);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
        }

        getTransactions(fromDate, toDate).then((data)=>{
            if(data?.count)
                setTotalRecords(data.count);

            if(data?.transactions != null)
                setTransactionData(data.transactions);
        });
    }

    const openInvoice = (id) =>{
        setExpanded(-1);
        getInvoiceData(id).then(
            (data)=>{ window.open(data, '_blank');
            });

    }

    const paginate = (number) => {
        setCurrentPage(number);
    };

    return (
        <>
            <div className="navTabs mt-24 mb-24">
                <ul className="level1">
                    <li className={transactionType=='debit' ? "selected" : ""} onClick={(e)=>{e.preventDefault(); setTransactionType("debit")}}>
                        <a>Not Paid</a>
                    </li>
                    <li className={transactionType=='credit' ? "selected" : ""} onClick={(e)=>{e.preventDefault(); setTransactionType("credit")}}>
                        <a>Paid</a>
                    </li>
                </ul>
            </div>
            <div className="subContent">
                <div className="filterBlock dForm mb-16 account">
                    <div className="multiOption">
                        <h5 className="mb-8">Filter by</h5>
                        <div className={openSelect ? "selectBox open" : "selectBox"} onClick={()=>setOpenSelect(pre => !pre)}>
                            {selected==0 ?
                                <p className="selected">
                                This month {""}
                                <i className="material-symbols-rounded grey">expand_more</i>
                                </p>
                                :
                                <p className="selected">
                                    last {selected} months {""}
                                <i className="material-symbols-rounded grey">expand_more</i>
                                </p>
                            }
                            <div className="selectDrop">
                                <ul className="dropMenu">
                                    {/* <li class="selected">
                                                <a href="javascript:void(0);">Item Name One
                                                <i class="material-symbols-rounded">done</i></a>
                                            </li> */}
                                    <li className={selected==0? "selected" : ""} onClick={()=>{setSelected(0); setCurrentPage(1); }}>
                                        <a href="javascript:void(0);">This month</a>
                                    </li>
                                    <li className={selected==3? "selected" : ""} onClick={()=>{setSelected(3); setCurrentPage(1); }}>
                                        <a href="javascript:void(0);">last 3 months</a>
                                    </li>
                                    <li className={selected==6? "selected" : ""} onClick={()=>{setSelected(6); setCurrentPage(1); }}>
                                        <a href="javascript:void(0);">last 6 months</a>
                                    </li>
                                    <li className={selected==12? "selected" : ""} onClick={()=>{setSelected(12); setCurrentPage(1); }}>
                                        <a href="javascript:void(0);">last 12 months</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/*<div className="multiOption">*/}
                    {/*    <h5 className="mb-8">Download report</h5>*/}
                    {/*    <div className="selectBox">*/}
                    {/*        <p>*/}
                    {/*            Select duration*/}
                    {/*            <i className="material-symbols-rounded grey">expand_more</i>*/}
                    {/*        </p>*/}
                    {/*        <div className="selectDrop">*/}
                    {/*            <ul className="dropMenu">*/}
                    {/*                /!* <li class="selected">*/}
                    {/*                                <a href="javascript:void(0);">Item Name One*/}
                    {/*                                <i class="material-symbols-rounded">done</i></a>*/}
                    {/*                            </li> *!/*/}
                    {/*                <li>*/}
                    {/*                    <a href="javascript:void(0);">Item Name Two</a>*/}
                    {/*                </li>*/}
                    {/*                <li>*/}
                    {/*                    <a href="javascript:void(0);">Item Name Three</a>*/}
                    {/*                </li>*/}
                    {/*            </ul>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                <div className="dataTableDynamic ">
                    {isLoading ?
                    <p>Loading...</p>
                    :
                    <table>
                        <tbody>
                        <tr>
                            <th>Date</th>
                            <th>Customer Name</th>
                            <th>Package</th>
                            <th>Sum</th>
                            <th>Invoice ID</th>
                            <th>Status</th>
                                    {
                                        transactionType=="debit"&& <th>&nbsp;</th>
                            }
                           
                        </tr>
                        {   transactionData.length != 0?
                                transactionData.map((item)=>{
                                    return(
                                        <>
                                            <tr className={expanded==item.transaction_id ?"active" : ""}>
                                                <td className="vName">{item.transaction_date}</td>
                                                {item?.order_details?.customer_name != undefined && item?.order_details?.customer_name !== ""
                                                    ?
                                                    <td>{item.order_details.customer_name.charAt(0).toUpperCase()+ item.order_details.customer_name.slice(1)}</td>
                                                    :
                                                    <td>NA</td>
                                                }
                                                {item?.order_details?.package_name ? <td>{item.order_details.package_name}</td> : <td>NA</td>}
                                                {transactionType == 'debit' ?
                                                    <td className="error">${Math.abs(item.debit_amount)}</td>
                                                    :
                                                    <td className="success">${item.credit_amount}</td>
                                                }
                                                {item.invoice_no ? <td>{item.invoice_no}</td>: <td>NA</td>}
                                                {transactionType == 'debit' ? <td>Not paid</td> : <td>Paid</td>}
                                                {/*<td className="right" onClick={()=>{if(expanded == -1){ getBookingDetails(item.entity_id).then((data)=>{setExpanded(item.transaction_id);});} else{setExpanded(-1); if(expanded == -1){getBookingDetails(item.entity_id).then((data)=>{setExpanded(item.transaction_id);});} }}}>*/}
                                                {
                                                    transactionType == "debit" &&
                                                    <td className="right" onClick={() => { if (expanded == item.transaction_id) { setExpanded(-1) } else getBookingDetails(item.entity_id).then((data) => { setExpanded(item.transaction_id); }); }}>
                                                {transactionType == "debit" &&
                                               
                                                    <i className={expanded==item.transaction_id ? "material-symbols-rounded arrowTop mt-l":  "material-symbols-rounded arrowBottom mt-l"}>
                                                        expand_more
                                                    </i>
                                               
                                                    }
                                                     </td>
                                                }
                                              
                                                  
                                               
                                            </tr>
                                            {expanded == item.transaction_id && <BillSummary summary={summaryData} downloadInvoice = {()=>openInvoice(item.entity_id)}/>}
                                        </>
                                    )
                                })
                                    :
                                <tr><td>No data found</td></tr>
                        }

                        {
                        }

                        </tbody>
                    </table>
                    }
                </div>
            </div>
            {total_records > 10 && <Pagination
                paginate={paginate}
                currentPage={currentPage}
                usersPerPage={usersPerPage}
                total_records={total_records}
                setUsersPerPage={setUsersPerPage}
                setCurrentPage={setCurrentPage}
            />}
        </>
    );
}

export default TransactionList;